import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import Utm from 'geodesy/utm.js';
import LatLon from 'geodesy/latlon-ellipsoidal.js';
import { GeoLoc, DictHandler } from 'src/app/types/@types/sl-v-types';
import { SLMap } from 'src/app/model/sl-map';
// @ts-ignore
import { LngLat } from '!mapbox-gl';

@Component({
	selector: 'app-utm-form',
	templateUrl: './utm-form.component.html',
	styleUrls: ['./utm-form.component.scss']
})
export class UtmFormComponent implements OnInit {

	@ViewChild('zoneNumberSel', { static: true }) zoneNumberSel: ElementRef;
	@ViewChild('zoneLetterSel', { static: true }) zoneLetterSel: ElementRef;
	@ViewChild('northingInput', { static: true }) northingInput: ElementRef;
	@ViewChild('eastingInput', { static: true }) eastingInput: ElementRef;

	public value: GeoLoc;
	private okHandler: DictHandler;
	private map: SLMap;


	get zoneNumber(): number {
		return Number(this.zoneNumberSel.nativeElement.value);
	}
	get zoneLetter(): string {
		return this.zoneLetterSel.nativeElement.value;
	}
	get northing(): number {
		return Number(this.northingInput.nativeElement.value);
	}
	get easting(): number {
		return Number(this.eastingInput.nativeElement.value);
	}

	constructor() { }
	Setup(slMap: SLMap, okHandler: DictHandler) {
		this.map = slMap;
		this.okHandler = okHandler;
	}
	ngOnInit() {
		$(this.zoneLetterSel.nativeElement).on('change', null, (event) => { this.UpdateValue(event); });
		$(this.zoneNumberSel.nativeElement).on('change', null, (event) => { this.UpdateValue(event); });
		$(this.northingInput.nativeElement).on('keyup', null, (event) => { this.UpdateValue(event); });
		$(this.eastingInput.nativeElement).on('keyup', null, (event) => { this.UpdateValue(event); });

	}
	UpdateValue(event: any) {

		if (isNaN(this.easting) || isNaN(this.northing)) {
			return;
		}
		try {
			const utm = Utm.parse(['' + this.zoneNumber, this.zoneLetter, this.easting, this.northing].join(' '), LatLon.datums.WGS84);
			const latLon: LatLon = utm.toLatLon();
			const lngLat: LngLat = new LngLat(latLon.lon, latLon.lat);
			this.value = { point: lngLat, limitToExtent: false };
			if (event.keyCode) {
				if (event.keyCode === 13) {
					if (this.okHandler) {
						this.okHandler(this.value);
					}
				}
			}
		} finally {
			delete this.value;
		}
	}

}
